var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('div',{staticClass:"maintenance__title"},[_vm._v("準備中です。")]),_c('div',[_vm._v("しばらくお待ちいただいてから　")]),_c('div',[_vm._v("再度アクセスをお試しください。")]),(_vm.maintenanceMessage)?_c('div',{staticClass:"maintenance__footer"},[_vm._v(_vm._s(_vm.maintenanceMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }